import React from 'react'

export default function PrimaryButton({ label, onClick, className }) {
    return (
        <button onClick={onClick} className={"btn btn-primary" + className}>
            {label}
        </button>
    )
}
